export default __webpack_public_path__ + "static/media/home.7d0e1d8e.jpg";